import { makeStyles } from '@material-ui/core/styles';
import { Theme } from 'enum';

export const useStyle = makeStyles((theme) => {
    const isLightMode = theme.palette.type === Theme.Light;
    return {
        root: {
            padding: '25px 0',
            position: 'relative',
            backgroundColor: isLightMode ? 'rgb(250,250,250)' : 'rgb(38,38,38)',
        },
        content: {
            position: 'relative',
            [theme.breakpoints.up('md')]: {
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                marginBottom: '10px',
                '&::before': {
                    content: ' ',
                    display: 'flex',
                },
            },
            [theme.breakpoints.down('sm')]: {
                paddingBottom: theme.spacing(2),
            },
        },
        leftSide: {
            position: 'relative',
            paddingRight: '30px',
            flex: 1,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: theme.spacing(4, 0),
            [theme.breakpoints.down('sm')]: {
                paddingTop: 0,
                paddingBottom: theme.spacing(2),
            },
            [theme.breakpoints.down(400)]: {
                padding: theme.spacing(2, 0),
                paddingTop: 0,
            },
        },
        inviteButtonsContainer: {
            [theme.breakpoints.down('xs')]: {
                marginTop: '24px',
            },
            marginBottom: 'auto',
        },
        viewCount: {
            display: 'flex',
            alignItems: 'center',
            position: 'absolute',
            bottom: -16,
        },
        verified: {
            color: theme.palette.success.main,
            marginLeft: 5,
            fontSize: '1.1rem',
        },
        logo: {
            padding: 0,
            overflow: 'hidden',
            width: 140,
            height: 140,
            flex: '0 0 140px',
            marginRight: theme.spacing(3),
            backgroundColor: '#fff',
            display: 'flex',
            '& a': {
                display: 'flex',
                width: '100%',
            },
            '& img': {
                cursor: 'pointer',
                width: '100%',
                height: '100%',
                objectFit: 'contain',
            },
            [theme.breakpoints.down('sm')]: {
                width: 90,
                height: 90,
                flex: '0 0 90px',
            },
            [theme.breakpoints.down(400)]: {
                width: 60,
                height: 60,
                flex: '0 0 60px',
                marginRight: theme.spacing(2),
            },
        },
        defaultLogo: {
            backgroundColor: isLightMode ? theme.palette.background.paper : theme.palette.background.default,
            '& img': {
                filter: isLightMode ? 'invert(0)' : 'invert(1)',
            },
        },
        companyName: {
            margin: 0,
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            overflow: 'hidden',
            display: '-webkit-box',
        },
        detail: {
            width: '100%',
            marginRight: '0px',
            marginTop: ' -2px',
            '& span': {
                fontSize: '14px',
                marginRight: '3px',
                color: theme.palette.text.secondary,
                [theme.breakpoints.up('md')]: {
                    fontSize: '16px',
                },
            },
        },
        salaryBox: {
            padding: '22px 30px',
            backgroundColor: isLightMode ? 'rgb(255,255,255)' : 'rgb(42,42,42)',
            [theme.breakpoints.down('sm')]: {
                padding: 0,
                boxShadow: 'none',
                backgroundColor: 'transparent',
                marginTop: theme.spacing(2),
            },
        },
        salaryType: {
            ...theme.typography.h5,
            color: theme.palette.text.secondary,
            margin: '3px 0 8px 0',
        },
        salaryAmount: {
            ...theme.typography.h2,
            color: '#4CAF50',
            marginTop: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                marginTop: theme.spacing(1),
            },
        },
        dialog: {
            '& .MuiAlert-root': {
                padding: theme.spacing(0, 1, 0, 1),
                display: 'flex',
                alignItems: 'center',
            },
            '& .MuiButton-root': {
                transition: 'none',
            },
            '& a': {
                display: 'flex',
                width: '100%',
            },
        },
        spinner: {
            height: '327px',
            display: 'flex',
            alignItems: 'center',
        },
        statusContainer: {
            justifyContent: 'flex-end',
            alignItems: 'center',
            paddingRight: theme.spacing(2),
            [theme.breakpoints.down('xs')]: {
                justifyContent: 'flex-start',
                marginTop: theme.spacing(3),
                paddingRight: theme.spacing(0),
            },
        },
        statusContent: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: theme.spacing(3),
            width: 'fit-content',
            padding: theme.spacing(1, 2),
            height: 'fit-content',
            [theme.breakpoints.down('xs')]: {
                width: '100%',
                textAlign: 'center',
                boxShadow: 'none !important',
            },
        },
        status: {
            fontSize: '14px',
            fontWeight: 700,
        },
        inviteRejected: {
            color: '#990808',
        },
        rejectedIcon: {
            fontSize: theme.spacing(2),
            marginRight: theme.spacing(1),
        },
    };
});
